// 需要隐藏左侧菜单的url
const urlList = [
    '/mng/account/wework/AppPrivilege',
    '/mng/account/wework/AppDetail',
];
export default urlList;
